import type { GeoPoint } from '../realtime/contracts';
import { getRelatedAgenciesForSharing } from './configuration';
import type { AgencyConfigurationDto, AgencyPortalConfigurationDto } from './configuration';

function toNumericEnum<TEnum extends number>(value: TEnum | string | number, names: Record<string, TEnum>): TEnum {
  if (typeof value === 'number') {
    return value as TEnum;
  }

  return names[value] ?? (value as unknown as TEnum);
}

export const MapLinkServices = {
  GoogleMaps: 1,
  MapyCz: 2,
  AirNavPro: 4,
} as const;
export type MapLinkServices = (typeof MapLinkServices)[keyof typeof MapLinkServices];

export type MapLayer = AgencyPortalConfigurationDto['mapConfiguration']['layers'][number];

export type MapConfigurationDto = {
  defaultPosition: GeoPoint;
  defaultZoom: number;
  mapyCzApiKey: string;
  layers: MapLayer[];
  mapLinks: MapLinkServices[];
  navigationMapLink: MapLinkServices;
};

type RawMapLayer = {
  id?: string | null;
  title?: string | null;
  isDefaultVisible?: boolean;
  borderColor?: string | null;
  fillColor?: string | null;
  geojsonUrl?: string | null;
};

type RawMapConfiguration = {
  defaultPosition?: GeoPoint;
  defaultZoom?: number;
  mapyCzApiKey?: string | null;
  layers?: RawMapLayer[] | null;
  mapLinks?: (number | string)[] | null;
  navigationMapLink?: number | string;
};

export function getMapConfiguration(agencyConfiguration: AgencyConfigurationDto): MapConfigurationDto {
  const rawValue: unknown = agencyConfiguration.agencyPortalConfiguration.mapConfiguration;
  const raw = (rawValue ?? {}) as RawMapConfiguration;

  return {
    defaultPosition: raw.defaultPosition ?? { latitude: 50.0755, longitude: 14.4378 },
    defaultZoom: raw.defaultZoom ?? 13,
    mapyCzApiKey: raw.mapyCzApiKey ?? '',
    layers: (raw.layers ?? []).map((layer) => ({
      id: layer.id ?? '',
      title: layer.title ?? '',
      isDefaultVisible: layer.isDefaultVisible ?? false,
      borderColor: layer.borderColor ?? '',
      fillColor: layer.fillColor ?? '',
      geojsonUrl: layer.geojsonUrl ?? '',
    })),
    mapLinks: (raw.mapLinks ?? []).map((link) => toNumericEnum<MapLinkServices>(link, MapLinkServices)),
    navigationMapLink: toNumericEnum<MapLinkServices>(
      raw.navigationMapLink ?? MapLinkServices.MapyCz,
      MapLinkServices,
    ),
  };
}

export function getShareIncidentRelatedAgencies(agencyConfiguration: AgencyConfigurationDto): string[] {
  return getRelatedAgenciesForSharing(agencyConfiguration).map((agency) => agency.id);
}

export const ALL_ATE_AGENCY_IDS: string[] = [
  '9f00a714-eb40-4748-8af1-392b0e81e7b0',
  '27d750a7-3a27-43f6-a665-a93f137f0202',
  '83fa0ca1-ba58-4477-a57f-95a9675b3621',
  '9081f402-8feb-4c0a-a013-b8cbba3bdffc',
  '3cc7df65-22bb-488a-9817-c2e8752a75b7',
  '8378e45f-b0df-44c0-8ce5-996bd0cbfd15',
  '470491fe-a1ba-4ced-badf-d0fc14f96328',
  '8796dbb0-4787-432d-af81-50bccdc4cca9',
];
